import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Loading',
    },
  },
  {
    path: '/chatrecord',
    name: 'ChatRecord',
    component: () => import('../views/chat/ChatRecord'),
    meta: {
      title: '聊天记录',
    },
  },
  {
    path: '/ct/:id',
    name: 'ChatRecord2',
    component: () => import('../views/chat/ChatRecord2'),
    meta: {
      title: '聊天记录',
    },
  },
  {
    path: '/dailyAct',
    name: 'DailyAct',
    component: () => import('../views/DailyJump'),
  },
  {
    path: '/dailyLinkAct',
    name: 'DailyLinkAct',
    component: () => import('../views/DailyJumpByLink'),
  },
  {
    path: '/dynamic',
    name: 'Dynamic',
    component: () => import('../views/dynamic/Dynamic'),
    meta: {
      title: '动态',
    },
  },
  // {
  //   path: '/oil',
  //   name: 'Oil',
  //   component: () => import('../views/otherJump/Oil'),
  //   meta: {
  //     title: '一键加油'
  //   }
  // },
  {
    path: '/elem',
    name: 'Elem',
    component: () => import('../views/elem/Elem'),
    meta: {
      title: '饿了么红包每天领',
    },
  },
  {
    path: '/elemOrder',
    name: 'ElemOrder',
    component: () => import('../views/elem/ElemOrder'),
    meta: {
      title: '饿了么红包每天领',
    },
  },
  {
    path: '/meituan',
    name: 'Meituan',
    component: () => import('../views/meituan/Meituan'),
    meta: {
      title: '美团外卖红包每天领',
    },
  },
  {
    path: '/meituanOrder',
    name: 'MeituanOrder',
    component: () => import('../views/meituan/MeituanOrder'),
    meta: {
      title: '美团外卖红包每天领',
    },
  },
  // {
  //   path: '/union',
  //   name: 'Union',
  //   component: () => import('../views/union/Union'),
  //   meta: {
  //     title: '商品集合页'
  //   }
  // },
  // {
  //   path: '/presale',
  //   name: 'Presale',
  //   component: () => import('../views/presale/Presale'),
  //   meta: {
  //     title: '618预售实时热销榜'
  //   }
  // },
  // {
  //   path: '/tbUnion',
  //   name: 'TBUnion',
  //   component: () => import('../views/tbUnion/TBUnion'),
  //   meta: {
  //     title: '活动榜单',
  //   },
  // },
  // {
  //   path: '/halfTel',
  //   name: 'HalfTel',
  //   component: () => import('../views/halfTel/Index'),
  //   meta: {
  //     title: '0点半价手机',
  //   }
  // },
  {
    path: '/gather',
    name: 'Gather',
    component: () => import('../views/gather/Gather'),
    meta: {
      title: '福利清单.xlsx',
    },
  },
  {
    path: '/mcGather',
    name: 'mcGather',
    component: () => import('../views/mcGather/Gather'),
    meta: {
      title: '猫超好货大放价',
    },
  },
  {
    path: '/gatherLower',
    name: 'gatherLower',
    component: () => import('../views/gatherLower/Gather'),
    meta: {
      title: '低价好物',
    },
  },
  {
    path: '/gatherXiaoyang',
    name: 'gatherXiaoyang',
    component: () => import('../views/gatherXiaoyang/Gather'),
    meta: {
      title: '小样种草机',
    },
  },
  {
    path: '/gatherHot',
    name: 'gatherHot',
    component: () => import('../views/gatherHot/Gather'),
    meta: {
      title: '热销专场',
    },
  },
  // {
  //   path: '/gatherHealthy',
  //   name: 'gatherHealthy',
  //   component: () => import('../views/gatherHealthy/Gather'),
  //   meta: {
  //     title: '防疫专场',
  //   },
  // },
  {
    path: '/gatherJhs',
    name: 'gatherJhs',
    component: () => import('../views/gatherJhs/Gather'),
    meta: {
      title: '聚划算热销精选',
    },
  },
  {
    path: '/jdTransform',
    name: 'JdTransform',
    component: () => import('../views/transform/jdTransform'),
    meta: {
      title: '京东转链工具',
    },
  },
  // {
  //   path: '/shoudan',
  //   name: 'ShouDan',
  //   component: () => import('../views/shouDan/ShouDan'),
  //   meta: {
  //     title: '首单礼金'
  //   }
  // },
  // {
  //   path: '/sd2',
  //   name: 'ShouDan2',
  //   component: () => import('../views/shouDan/ShouDan2'),
  //   meta: {
  //     title: '首单礼金'
  //   }
  // },
  // {
  //   path: '/taoMoney',
  //   name: 'TaoMoney',
  //   component: () => import('../views/taoMoney/TaoMoney'),
  //   meta: {
  //     title: '首单礼金'
  //   }
  // },
  // {
  //   path: '/cjf',
  //   name: 'CjfMoney',
  //   component: () => import('../views/chaojifan/Chaojifan'),
  //   meta: {
  //     title: '超级买返'
  //   }
  // },
  {
    path: '/transform',
    name: 'Transform',
    component: () => import('../views/transform/transform'),
    meta: {
      title: '一键转链',
    },
  },
  {
    path: '/transformH',
    name: 'TransformH',
    component: () => import('../views/transformH/transform'),
    meta: {
      title: '欢专用',
    },
  },
  {
    path: '/transformSign',
    name: 'TransformSign',
    component: () => import('../views/transform/transformSign'),
    meta: {
      title: '签到红包转链',
    },
  },
  {
    path: '/transformCjf',
    name: 'TransformCjf',
    component: () => import('../views/transform/transformCjf'),
    meta: {
      title: '超级返转链',
    },
  },
  // {
  //   path: '/yhShouDan',
  //   name: 'YhShouDan',
  //   component: () => import('../views/yhShouDan/YhShouDan'),
  //   meta: {
  //     title: '首单礼金'
  //   }
  // },
  // {
  //   path: '/sdPwd',
  //   name: 'sdPwd',
  //   component: () => import('../views/sdPwd/index'),
  //   meta: {
  //     title: '首单礼金'
  //   }
  // },
  {
    path: '/applyRobot',
    name: 'ApplyRobot',
    component: () => import('../views/applyRobot/ApplyRobot'),
    meta: {
      title: '申请发单机器人',
    },
  },
  // {
  //   path: '/firstOrder',
  //   name: 'FirstOrder',
  //   component: () => import('../views/firstOrder/FirstOrder'),
  //   meta: {
  //     title: '首单礼金'
  //   }
  // },
  // {
  //   path: '/test',
  //   name: 'Test',
  //   component: () => import('../views/test/Test'),
  //   meta: {
  //     title: '测试页面'
  //   }
  // },
  // {
  //   path: '/bridge',
  //   name: 'Bridge',
  //   component: () => import('../views/bridge/Bridge'),
  //   meta: {
  //     title: 'jsBridge测试页面'
  //   }
  // },
  // {
  //   path: '/liugan',
  //   name: 'LiuGan',
  //   component: () => import('../views/liugan/LiuGan'),
  //   meta: {
  //     title: '防疫必买专区'
  //   }
  // },
  {
    path: '/pdd',
    name: 'PddGather',
    component: () => import('../views/pddGather/PddGather'),
    meta: {
      title: '拼多多专区',
    },
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/auth/Auth'),
    meta: {
      title: '成为悦惠高级代理',
    },
  },
  {
    path: '/authSuccess',
    name: 'AuthSuccess',
    component: () => import('../views/auth/Success'),
    meta: {
      title: '授权成功',
    },
  },
  {
    path: '/authFail',
    name: 'AuthFail',
    component: () => import('../views/auth/Fail'),
    meta: {
      title: '授权失败',
    },
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/service/Service'),
    meta: {
      title: '联系客服',
    },
  },
  {
    path: '/618timeline',
    name: 'ActNhj',
    component: () => import('../views/activity/20231111TimeLine'),
    meta: {
      title: '双十一攻略',
    },
  },
  {
    path: '/shyh',
    name: 'Shyh',
    component: () => import('../views/shyh/index'),
    meta: {
      title: '周边生活特惠',
    },
  },
  // {
  //   path: '/nhjjd',
  //   name: 'Nhjjd',
  //   component: () => import('../views/jdnhj/Index'),
  //   meta: {
  //     title: '京东年货节'
  //   }
  // },
  // {
  //   path: '/tljgo',
  //   name: 'tljgo',
  //   component: () => import('../views/tljgo'),
  //   meta: {
  //     title: '1元购活动'
  //   }
  // },
  // {
  //   path: '/yyg',
  //   name: 'yyg',
  //   component: () => import('../views/activity/yyg'),
  //   meta: {
  //     title: '悦惠福利1元购'
  //   }
  // },
  // {
  //   path: '/tjb',
  //   name: 'tjb',
  //   component: () => import('../views/activity/tjb'),
  //   meta: {
  //     title: '淘宝特价版0.1元新人专享'
  //   }
  // },
  // {
  //   path: '/signProd',
  //   name: 'SignProd',
  //   component: () => import('../views/SignProd/index'),
  //   meta: {
  //     title: '签到红包抵扣商品'
  //   }
  // },
  // {
  //   path: '/yhActivity',
  //   name: 'YhActivity',
  //   component: () => import('../views/activity/yhActivity'),
  //   meta: {
  //     title: '悦惠5折天大促'
  //   }
  // },
  {
    path: '/jdProd',
    name: 'JdProd',
    component: () => import('../views/jdProd/index'),
    meta: {
      title: '京东活动中心',
    },
  },
  {
    path: '/jd618',
    name: 'jd618',
    component: () => import('../views/activity/jd618'),
    meta: {
      title: '京东极速版礼金活动',
    },
  },
  // {
  //   path: '/jdchunwan',
  //   name: 'jdChunwan',
  //   component: () => import('../views/activity/jdChunWan'),
  //   meta: {
  //     title: '邀你瓜分京东15亿',
  //   },
  // },
  {
    path: '/jdActivity',
    name: 'jdActivity',
    component: () => import('../views/activity/jdActivity'),
    meta: {
      title: '京东活动',
    },
  },
  // {
  //   path: '/jdNewYear',
  //   name: 'jdNewYear',
  //   component: () => import('../views/activity/jdNewYear'),
  //   meta: {
  //     title: '京东新年一元购',
  //   },
  // },
  // {
  //   path: '/jdAct',
  //   name: 'jdAct',
  //   component: () => import('../views/activity/jdAct'),
  //   meta: {
  //     title: '京东活动',
  //   },
  // },
  {
    path: '/commonSearch',
    name: 'CommonSearch',
    component: () => import('../views/commonSearch/Index'),
    meta: {
      title: '搜索',
    },
  },
  {
    path: '/tbSearch',
    name: 'TbSearch',
    component: () => import('../views/tbSearch/Index'),
    meta: {
      title: '搜索',
    },
  },
  // {
  //   path: '/xianbao',
  //   name: 'Xianbao',
  //   component: () => import('../views/xianbao/index'),
  //   meta: {
  //     title: '线报'
  //   }
  // },
  {
    path: '/wfr',
    name: 'wfr',
    component: () => import('../views/activity/wfr'),
    meta: {
      title: '活动',
    },
  },
  {
    path: '/xb',
    name: 'xb',
    component: () => import('../views/activity/xianbao'),
    meta: {
      title: '线报中心',
    },
  },
  {
    path: '/xbgzh',
    name: 'xbgzh',
    component: () => import('../views/activity/xianbaoGzh'),
    meta: {
      title: '线报中心',
    },
  },
  {
    path: '/huafei',
    name: 'huafei',
    component: () => import('../views/activity/huafei'),
    meta: {
      title: '话费电费优惠',
    },
  },
  // {
  //   path: '/yhActProd',
  //   name: 'yhActProd',
  //   component: () => import('../views/yhActProd/Index'),
  //   meta: {
  //     title: '悦惠1元购',
  //   },
  // },
  {
    path: '/DyCopyText',
    name: 'DyCopyText',
    component: () => import('../views/activity/DyCopyText'),
    meta: {
      title: '抖音跳转',
    },
  },
  {
    path: '/userTasks',
    name: 'userTasks',
    component: () => import('../views/userTasks/Index.vue'),
    meta: {
      title: '运营待办',
    },
  },
  {
    path: '/timelineToday',
    name: 'timelineToday',
    component: () => import('../views/timelineToday/Index.vue'),
    meta: {
      title: '今日精选',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
